import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class BaseInstitutionEntity {
    id: string;
    institutionId: string;
    createdAt: Date;
    createdByIdentifier: EntityIdentifier;
    updatedAt: Date;
    updatedByIdentifier: EntityIdentifier;
}
